export default __webpack_public_path__ + "static/media/ok2.79bb755d.jpg";